module.exports = __webpack_public_path__ + "static/media/ghost-user-avatar-light.2db56d14.png";